"use client";

import { useFormStatus } from "react-dom";
import { sendLink } from "./actions";
import styles from "./signin.module.css";

function Submit() {
  const { pending } = useFormStatus();
  return (
    <button className="btn btn--primary btn--wide btn--big" type="submit" data-busy={pending} disabled={pending}>
      {pending ? "Sending" : "Send my link"}
    </button>
  );
}

/* Four answers rather than a box to write in, because a fixed set can be counted and a
   written one cannot. "Just looking" is there so that nobody who is none of the other three
   feels asked to lie. */
const WHO = [
  { value: "native", label: "From here" },
  { value: "moved", label: "Just moved" },
  { value: "visiting", label: "Visiting" },
  { value: "looking", label: "Just looking" },
];

type Props = {
  next: string;
  first?: string;
  last?: string;
  email?: string;
  why?: string;
};

export function SendLink({ next, first = "", last = "", email = "", why }: Props) {
  return (
    <form action={sendLink} className={styles.form}>
      <input type="hidden" name="next" value={next} />

      <div className={styles.names}>
        <div className={styles.field}>
          <label className="label" htmlFor="first_name">First name</label>
          <input
            className="field"
            id="first_name"
            name="first_name"
            type="text"
            required
            maxLength={40}
            autoComplete="given-name"
            defaultValue={first}
            autoFocus
            aria-describedby={why === "first" ? "name-err" : undefined}
            placeholder="Diego"
          />
        </div>
        <div className={styles.field}>
          <label className="label" htmlFor="last_name">Last name</label>
          <input
            className="field"
            id="last_name"
            name="last_name"
            type="text"
            maxLength={40}
            autoComplete="family-name"
            defaultValue={last}
            placeholder="Optional"
          />
        </div>
      </div>
      {why === "first" && <p id="name-err" className={styles.err}>We need a first name to say hello with.</p>}

      <div className={styles.field}>
        <label className="label" htmlFor="email">Email</label>
        <input
          className="field"
          id="email"
          name="email"
          type="email"
          required
          autoComplete="email"
          inputMode="email"
          defaultValue={email}
          aria-describedby={why === "email" || why === "send" ? "email-err" : undefined}
          placeholder="you@example.com"
        />
      </div>
      {why === "email" && <p id="email-err" className={styles.err}>That address doesn't look right.</p>}
      {why === "send" && <p id="email-err" className={styles.err}>That didn't send. Try once more.</p>}

      {/* Both optional, and said to be optional out loud. Somebody who just landed here
          wants different things from somebody who grew up on the same block, and knowing
          which one you are is the difference between a good first tip and a wasted one. */}
      <fieldset className={styles.extras}>
        <legend className="label">Which one are you? Skip it if you like</legend>
        <div className={styles.chips}>
          {WHO.map((w) => (
            <label key={w.value} className={styles.chip}>
              <input type="radio" name="who" value={w.value} />
              <span>{w.label}</span>
            </label>
          ))}
        </div>
      </fieldset>

      <div className={styles.field}>
        <label className="label" htmlFor="heard">How did you find us? Optional</label>
        <input
          className="field"
          id="heard"
          name="heard"
          type="text"
          maxLength={120}
          placeholder="A friend, Reddit, walked past a sticker"
        />
      </div>

      <Submit />
    </form>
  );
}
